import round from 'lodash/round'
import { v4 as uuid } from 'uuid'

export const defaultTrafficSourceGroup = {
  cpc: null,
  cpa: null,
  invoice_cpc: null,
  invoice_cpa: null,
  sourceIndexes: [],
  rateCpc: null,
  rateCpa: null,
  rateInvoiceCpc: null,
  rateInvoiceCpa: null,
  invoiceRate: null,
}

const normalizeInvoicePrice = (price, isCpc) => {
  // if price is null then return
  if (price === undefined || price === null) return null

  return isCpc ? price / 100 : round(price * 100, 2)
}

export const normalizeTrafficSourceCosts = (trafficSourceCosts) => {
  const groups = []

  trafficSourceCosts.forEach((item) => {
    // Combine traffic sources by their values
    const group = groups.find(
      (group) =>
        group.cpa === item.cpa &&
        group.cpc === item.cpc &&
        group.invoice_cpa === item.invoice_cpa &&
        group.invoice_cpc === item.invoice_cpc,
    )

    if (group) {
      group.sourceIndexes.push(item.source)
    } else {
      groups.push({
        key: uuid(),
        id: item.id,
        createdAt: item.created_at,
        updatedAt: item.updated_at,
        userRevenue: item.user_revenue,
        clientRevenue: item.client_revenue,
        offerId: item.offer_id,
        cpa: item.cpa,
        cpc: item.cpc,
        invoice_cpa: item.invoice_cpa,
        invoice_cpc: item.invoice_cpc,
        rateCpc: item.cpc / 100,
        rateCpa: round(item.cpa * 100, 2),
        rateInvoiceCpc: normalizeInvoicePrice(item.invoice_cpc, true),
        rateInvoiceCpa: normalizeInvoicePrice(item.invoice_cpa, false),
        sourceIndexes: [item.source],
      })
    }
  })

  return groups
}

export const isEmptyValue = (value) => value === undefined || value === null || value === ''
const serializeCostValue = (value, pairedValue, isCPC) => {
  if (isEmptyValue(value)) {
    return isEmptyValue(pairedValue) ? null : 0
  }

  return isCPC ? round(value * 100) : round(value / 100, 6)
}

const hasCostValue = (data) => {
  return (
    !isEmptyValue(data.rateCpc) || !isEmptyValue(data.rateCpa) || !isEmptyValue(data.rateInvoiceCpc) || !isEmptyValue(data.rateInvoiceCpa)
  )
}

export const serializeTrafficSourceCosts = (groupedTrafficSourceCosts) => {
  const trafficSourceCosts = []
  groupedTrafficSourceCosts.forEach((item) => {
    if (hasCostValue(item)) {
      item.sourceIndexes.forEach((sourceIndex) => {
        trafficSourceCosts.push({
          source: sourceIndex,
          cpc: serializeCostValue(item.rateCpc, item.rateCpa, true),
          cpa: serializeCostValue(item.rateCpa, item.rateCpc, false),
          invoice_cpc: serializeCostValue(item.rateInvoiceCpc, item.rateInvoiceCpa, true),
          invoice_cpa: serializeCostValue(item.rateInvoiceCpa, item.rateInvoiceCpc, false),
          ...(item.id && { id: item.id }),
          ...(item.offerId && { offer_id: item.offerId }),
          ...(item.createdAt && { created_at: item.createdAt }),
          ...(item.updatedAt && { updated_at: item.updatedAt }),
          ...(item.userRevenue && { user_revenue: item.userRevenue }),
          ...(item.clientRevenue && { client_revenue: item.clientRevenue }),
        })
      })
    }
  })

  return trafficSourceCosts
}
